import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Section } from './ui/Section';
import { FiMessageSquare } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const JACOB_PORTRAIT = 'https://media-manager-c.questera.ai/greta-media/9156b7ad9768dabbd1486a5021f9991fb512a0d6d6c844e6b5b41380a57b274ba7bc4b27b2a4de1f0a85d0c05b5620e1/images/aW1hZ2UvanBlZw==/a3c378ff90102a4a66b1f08ebf9feea8.jpg';

const Testimonials = () => {
  const { t } = useLanguage();

  if (!t.testimonials || t.testimonials.length === 0) return null;

  return (
    <Section bg="bg-brand-darker border-y border-brand-border/30">
      <div className="max-w-4xl mx-auto">
        <div className="grid gap-12">
          {t.testimonials.map((item, i) => (
            <div key={i} className="bg-brand-card border border-brand-border p-8 md:p-12 rounded-2xl relative overflow-hidden group">
              {/* Decorative background icon */}
              <SafeIcon
                icon={FiMessageSquare}
                className="absolute -top-4 -right-4 w-32 h-32 text-brand-accent/5 -rotate-12 transition-transform duration-500 group-hover:scale-110"
              />

              <div className="relative z-10">
                <p className="text-xl md:text-2xl text-brand-textHeading italic leading-relaxed mb-10 font-medium">
                  {item.quote}
                </p>

                <div className="flex items-center gap-5">
                  {item.image && (
                    <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-brand-accent/20 flex-shrink-0">
                      <img
                        src={item.author === 'Jacob Fischer-Nielsen' ? JACOB_PORTRAIT : item.image}
                        alt={item.author}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  <div>
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-lg font-bold text-brand-textHeading hover:text-brand-accent transition-colors block"
                    >
                      {item.author}
                    </a>
                    <p className="text-brand-textMuted text-sm font-medium uppercase tracking-wider">
                      {item.role}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Testimonials;